'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'block-question';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e3dd';
var svgPathData = 'M16 48l0 416 416 0 0-416-416 0zM0 32l448 0 0 448-448 0 0-448zM80 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm272 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM80 384a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm272 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM136 192c0-30.9 25.1-56 56-56l56.2 0c35.2 0 63.8 28.6 63.8 63.8 0 21.4-10.8 41.5-28.7 53.3l-51.3 33.8 0 33.1-16 0 0-41.8 3.6-2.4 54.9-36.2c13.4-8.8 21.5-23.8 21.5-39.9 0-26.4-21.4-47.8-47.8-47.8L192 152c-22.1 0-40 17.9-40 40l0 6.5-16 0 0-6.5zm72 152l32 0 0 32-32 0 0-32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBlockQuestion = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;